var Platform = require('react-native').Platform;

exports._os = Platform.OS;
